import { useEffect } from "react";

export default function StudentLogin() {
  useEffect(() => {
    // Set the student session token
    localStorage.setItem("session_token", "student_token_1762460375989");
    
    // Redirect to home (which will then redirect to student dashboard)
    setTimeout(() => {
      window.location.href = "/";
    }, 500);
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-blue-700 font-medium">Logging you in as Student...</p>
      </div>
    </div>
  );
}
